<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a href="javascript:;" class="btn btn-secondary w-60 display-6"  @click="handleClearFilters"> Clear Filters </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
  <div class="row filter-row">
    
      
    <div class="col-sm-6 col-md-2 position-relative">

      <div class="input-block mb-3 form-focus select-focus ">
         <vue-select :style="`${ filters.employee_status && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="employmentStatuses" placeholder="Select Status" id="design" v-model="filters.employee_status" />
          <label class="focus-label">Employement Status</label>
      </div>
        <i v-if="filters.employee_status" @click="handleClearOneFilter('employee_status')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus ">
        <vue-select :style="`${ filters.division && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="divisions" v-model="filters.division"  placeholder="Select Division" id="design3" />
        <label class="focus-label">Division</label>
        
      </div>
      <i v-if="filters.division" @click="handleClearOneFilter('division')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus">
        <vue-select :style="`${ filters.department && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="departments" v-model="filters.department" placeholder="Select Department" id="design2"  />
        <label class="focus-label">Department</label>
        
      </div>
      <i v-if="filters.department" @click="handleClearOneFilter('department')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus text-truncate ">
        <vue-select :style="`${ filters.campaign && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="campaigns" v-model="filters.campaign" placeholder="Select Campaign" id="design4" />
        <label class="focus-label">Campaign</label>
        
      </div>
      <i v-if="filters.campaign" @click="handleClearOneFilter('campaign')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus ">
        <vue-select :style="`${ filters.section && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="sections" v-model="filters.section" placeholder="Select Section" id="design5" />
        <label class="focus-label">Section</label>
        
      </div>
      <i v-if="filters.section" @click="handleClearOneFilter('section')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus ">
        <vue-select :style="`${ filters.designation && 'border-bottom: var(--primary-color) 2px solid;'}`"  :options="designations" v-model="filters.designation" placeholder="Select Designation" id="design6" />
        <label class="focus-label">Designation</label>
        
      </div>
      <i v-if="filters.designation" @click="handleClearOneFilter('designation')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus text-truncate">
        <vue-select :style="`${ filters.project && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="projects" v-model="filters.project" placeholder="Select Project" id="design7" />
        <label class="focus-label">Project</label>
        
      </div>
      <i v-if="filters.project" @click="handleClearOneFilter('project')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>

    <div class="col-sm-6 col-md-2 position-relative">

      <div class="input-block mb-3 form-focus select-focus ">
         <vue-select :style="`${ filters.employee_wfh && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="employmentWfhStatuses" placeholder="Select Status" id="design8" v-model="filters.employee_wfh" />
          <label class="focus-label">Employee WFH Status</label>
      </div>
        <i v-if="filters.employee_wfh" @click="handleClearOneFilter('employee_wfh')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>

    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocused }">
        <input
          type="text"
          :style="`${ filters.employee_id && 'border-bottom: var(--primary-color) 2px solid;'}`"
          class="form-control floating"
          v-model="filters.employee_id"
          @focus="isFocused = true"
          @blur="isFocused = employee_id !== ''"
        />
        <label class="focus-label">Employee ID</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedOn }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.employee_name && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.employee_name"
          @focus="isFocusedOn = true"
          @blur="isFocusedOn = employee_name !== ''"
        />
        <label class="focus-label">Employee Name</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedFirstName }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.first_name && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.first_name"
          @focus="isFocusedFirstName = true"
          @blur="isFocusedFirstName = first_name !== ''"
        />
        <label class="focus-label">First Name</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedLastName }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.last_name && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.last_name"
          @focus="isFocusedLastName = true"
          @blur="isFocusedLastName = last_name !== ''"
        />
        <label class="focus-label">Last Name</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedCnic }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.employee_cnic && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.employee_cnic"
          @focus="isFocusedCnic = true"
          @blur="isFocusedCnic = employee_cnic !== ''"
        />
        <label class="focus-label">CNIC</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedContact }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.employee_contact && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.employee_contact"
          @focus="isFocusedContact = true"
          @blur="isFocusedContact = employee_contact !== ''"
          @input="filters.employee_contact = filters.employee_contact.replace(/[^0-9-+ ]/g, '')"
        />
        <label class="focus-label">Contact #</label>
      </div>
    </div>
     <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedEmail }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.employee_email && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.employee_email"
          @focus="isFocusedEmail = true"
          @blur="isFocusedEmail = employee_email !== ''"
        />
        <label class="focus-label">Email</label>
      </div>
    </div>
     <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedPsuedoName }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.pseudo && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.pseudo"
          @focus="isFocusedPsuedoName = true"
          @blur="isFocusedPsuedoName = pseudo !== ''"
        />
        <label class="focus-label">Pseudo Name</label>
      </div>
    </div>
    <div class="col-md-1">
    </div>
    <div class="d-flex col-sm-6 col-md-3 gap-2">
      <button type="submit" href="javascript:;" class="btn btn-success w-100"  @click.prevent="handleFilters"> Search </button>
      <button type="button" href="javascript:;" class="btn btn-success w-100"  @click.prevent="resetAllFilters"> Reset </button>
    </div>
    
  </div>
</form>
</template>

<script>
import EmploymentStatusService from '@/services/EmploymentStatusService';
import DepartmentService from '@/services/DepartmentService';
import DivisionService from '@/services/DivisionService';
import CampaignService from '@/services/CampaignService';
import SectionService from '@/services/SectionService';
import DesignationService from '@/services/DesignationService';
import EmployeeProjectService from '@/services/EmployeeProjectService';

export default {
  data() {
    return {
      select2: null,
      Company: ["Select Company", "Global Technologies", "Delta Infotech"],
      isFocused: false,
      filters:{
      employee_id: "",
      employee_name: "",
      first_name: "",
      last_name: "",
      employee_cnic:"",
      employee_contact:"",
      employee_email:"",
      pseudo:"",
      project:"",
      employee_status:"",
      employee_wfh:'',
      department: "",
      division: "",
      campaign: "",
      section: "",
      designation: ""
      },

      isFocusedOn: false,
      isFocusedFirstName: false,
      isFocusedLastName: false,
      isFocusedCnic:"",
      isFocusedContact:"",
      isFocusedEmail:"",
      isFocusedPsuedoName:"",
      isFocusedEmpStatus:"",
      selectedDesignation:"",
      employmentStatuses: [],
      employmentWfhStatuses: ['yes' , 'no'],
      departments:[],
      divisions: [],
      campaigns: [],
      projects: [],
      sections: [],
      designations:[],
      searched: false,


    };
  },
  props:{
  },
  methods: {
    handleFilters(value) {
      
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit('apply-filters', this.filters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(el => !!el).length;
      if(this.searched) {
        this.$emit('apply-filters', this.filters);
       }
      if(!filtersHasProperty) {
          this.searched = false
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    async fetchEmploymentStatuses() {
            try {
                const response = await EmploymentStatusService.getStatuses();
                this.employmentStatuses = response?.data.map(el => el.status_name);
                  
                // through ID
                // this.employmentStatuses = response.data.map(el => ({id: el.id, text: el.status_name}));

            } catch (error) {
                console.error('Error fetching countries:', error);
            }
        },

    handleClearFilters() {
      this.$emit('apply-filters', {});
      this.filters =  {
      employee_id: "",
      employee_name: "",
      first_name: "",
      last_name: "",
      employee_cnic:"",
      employee_contact:"",
      employee_email:"",
      pseudo:"",
      project:"",
      employee_status:"",
      employee_wfh:'',
      department: "",
      division: "",
      campaign: "",
      section: "",
      designation: ""};
      this.searched = false;

    }   
  },
 async created() {
    this.searched = false
    this.fetchEmploymentStatuses();
    this.designations = (await DesignationService.getDesignations())?.data.map(el => el.designation_name);
    this.divisions = (await DivisionService.getDivisions())?.data.map(el => el.name);
    this.departments = (await DepartmentService.getDepartments())?.data.map(el => el.name);
    this.campaigns = (await CampaignService.getCampaigns())?.data.map(el => el.campaigns);
    this.projects = (await EmployeeProjectService.fetch())?.data.map(el => el.project_name);
    this.sections = (await SectionService.getSections())?.data.map(el => el.section_name);

    
    // through ID
    // this.designations = (await DesignationService.getDesignations()).data.map(el => ({id: el.id, text: el.designation_name}));
    // this.divisions = (await DivisionService.getDivisions()).data.map(el => ({id: el.id, text:el.name}));
    // this.departments = (await DepartmentService.getDepartments()).data.map(el => ({id: el.id, text:el.name}));
    // this.campaigns = (await CampaignService.getCampaigns()).data.map(el => ({id:el.id, text: el.campaigns}));
    // this.sections = (await SectionService.getSections()).data.map(el => ({id: el.id, text: el.section_name}));
  },

  computed: {
    isFilterApplied() {
        const filtersHasProperty = Object.values(this.filters).filter(el => !!el).length;

      return this.searched && filtersHasProperty
    }

    
  },


};
</script>
